export default __webpack_public_path__ + "static/media/iconmonstr-discord-1.c93a6d20.svg";